import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "theme"
const DARK = "dark"
const LIGHT = "light"

export default class extends Controller {
  static targets = ["darkIcon", "lightIcon"]

  connect() {
    this.syncIcons()
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle(DARK)
    localStorage.setItem(STORAGE_KEY, isDark ? DARK : LIGHT)
    this.syncIcons()
  }

  syncIcons() {
    const isDark = document.documentElement.classList.contains(DARK)
    this.darkIconTarget.classList.toggle("hidden", !isDark)
    this.lightIconTarget.classList.toggle("hidden", isDark)
  }
}
